import axios from "../utils/axios";

// Create new order (WhatsApp + Database)
export const createWhatsAppOrderApi = (data) =>
  axios.post("/api/orders/whatsapp", data);

// Get all orders with filters
// export const getAllOrdersApi = (params = {}) =>
//   axios.get("/api/orders", { params });

// Get all orders with filters
export const getAllOrdersApi = (filters = {}) => {
  const params = new URLSearchParams();
  
  // ✅ ALL FILTERS INCLUDING SEARCH
  if (filters.search) params.append("search", filters.search);
  if (filters.status) params.append("status", filters.status);
  if (filters.orderType) params.append("orderType", filters.orderType);
  if (filters.startDate) params.append("startDate", filters.startDate);
  if (filters.endDate) params.append("endDate", filters.endDate);
  if (filters.page) params.append("page", filters.page);
  if (filters.limit) params.append("limit", filters.limit);
  if (filters.sortBy) params.append("sortBy", filters.sortBy);
  if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);
  
  const queryString = params.toString();
  const url = queryString ? `/api/orders?${queryString}` : "/orders";
  return axios.get(url);
};


// Get single order by ID
export const getOrderByIdApi = (id) =>
  axios.get(`/api/orders/${id}`);

// Update order status
export const updateOrderStatusApi = (id, status) =>
  axios.put(`/api/orders/${id}/status`, { status });

// Update order details
export const updateOrderApi = (id, data) =>
  axios.put(`/api/orders/${id}`, data);

// Delete/Cancel order
export const deleteOrderApi = (id) =>
  axios.delete(`/api/orders/${id}`);

// Get order statistics
export const getOrderStatsApi = () =>
  axios.get("/api/orders/stats");

// Get orders by date range
export const getOrdersByDateRangeApi = (startDate, endDate) =>
  axios.get("/api/orders", {
    params: {
      startDate,
      endDate,
      limit: 1000 // Get all orders in date range
    }
  });